"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowButton_1 = require("../../atoms/ArrowButton/ArrowButton");
function DropdownWithSearchArrow({ isOpen, currentValue, disabled, placeholder, dataVisibleHeight, popupContent, className, onTogglePopup, onSearch, }) {
    const fieldRef = (0, react_1.useRef)(null);
    const onToggle = () => {
        onTogglePopup();
        if (fieldRef && fieldRef.current && !isOpen) {
            fieldRef.current.focus();
        }
    };
    const onFocus = () => {
        if (!isOpen) {
            onTogglePopup();
        }
    };
    const expanded = isOpen ? ArrowButton_1.Direction.Top : ArrowButton_1.Direction.Bottom;
    return ((0, jsx_runtime_1.jsxs)(Container, { role: "combobox", "aria-expanded": isOpen, "aria-owns": "country-list", "aria-haspopup": "listbox", "aria-labelledby": "country-label", className: className, tabIndex: 0, "data-e2e": 'DropdownWithSearchArrow_Container', children: [(0, jsx_runtime_1.jsx)(Label, { id: "dropdown-label", htmlFor: "dropdown-input", "data-e2e": 'DropdownWithSearchArrow_Label', children: "Type your country name or choose from the dropdown" }), (0, jsx_runtime_1.jsx)(Field, { ref: fieldRef, disabled: disabled, dataVisibleHeight: dataVisibleHeight, value: currentValue, placeholder: placeholder, onChange: (value) => onSearch(value), onFocus: onFocus, "aria-controls": "country-list", role: "searchbox", "data-e2e": 'DropdownWithSearchArrow_Field' }), !disabled && ((0, jsx_runtime_1.jsx)(StyledArrowButton, { onClick: onToggle, direction: expanded, "aria-label": "Expand country dropdown", "aria-haspopup": "listbox", "data-e2e": 'DropdownWithSearchArrow_StyledArrowButton' })), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen && !disabled, timeout: 250, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'DropdownWithSearchArrow_CSSTransition', children: popupContent() })] }));
}
exports.default = DropdownWithSearchArrow;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;

  opacity: 1;

  pointer-events: initial;
`;
const Field = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.Input) `
  flex-grow: 1;

  padding: 0 10px;

  color: inherit;

  border-radius: 4px;
`);
exports.Item = (0, styled_components_1.default)(ui_1.FlatButton) `
  flex-shrink: 0;
  margin: 0;
  padding: 8px 10px;

  color: ${props => props.theme.disabledSecondary};

  font-size: 14px;
  text-align: left;

  border-bottom: 1px solid
    ${props => props.theme.dashboard.buttons.darkSlateGray};
  border-radius: 4px;
`;
const StyledArrowButton = (0, styled_components_1.default)(ArrowButton_1.ArrowButton) `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin: 14px;

  height: 16px;
  width: 16px;
  color: ${props => props.theme.disabledSecondary};
`;
const Label = styled_components_1.default.label `
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
